import { Project } from '../models/project';
import { Skill } from '../models/skill';

const SKILLS: Skill[] = [
  {
    id: 1,
    name: 'HTML',
    icon: require('../assets/icons/html.svg').default,
  },
  {
    id: 2,
    name: 'CSS',
    icon: require('../assets/icons/css.svg').default,
  },
  {
    id: 3,
    name: 'JavaScript',
    icon: require('../assets/icons/javascript.svg').default,
  },
  {
    id: 4,
    name: 'SQL',
    icon: require('../assets/icons/sql.svg').default,
  },
  {
    id: 5,
    name: 'PhotoShop',
    icon: require('../assets/icons/photoshop.svg').default,
  },
  {
    id: 6,
    name: 'Figma',
    icon: require('../assets/icons/figma.svg').default,
  },
  {
    id: 7,
    name: 'Google Analytics',
    icon: require('../assets/icons/google_analytics.svg').default,
  },
  {
    id: 8,
    name: 'Git',
    icon: require('../assets/icons/git.svg').default,
  },
  {
    id: 9,
    name: 'MJML',
    icon: require('../assets/icons/mjml.svg').default,
  },
  {
    id: 10,
    name: 'Command Line',
    icon: require('../assets/icons/terminal.svg').default,
  },
  {
    id: 11,
    name: 'Email On Acid',
    icon: require('../assets/icons/acid.svg').default,
  },
  {
    id: 12,
    name: 'Litmus',
    icon: require('../assets/icons/litmus.svg').default,
  },
];

const PROJECT_FILTERS = [
  {
    label: 'All',
    value: 1,
  },
  {
    label: 'Landing Page',
    value: 2,
  },
  {
    label: 'HTML Emails',
    value: 3,
  },
  {
    label: 'Transactional Emails',
    value: 4,
  },
  {
    label: 'Promotional Emails',
    value: 5,
  },
  {
    label: 'Newsletter Emails',
    value: 6,
  },
];

const PROJECTS: Project[] = [
  {
    id: 1,
    name: 'PupFresh',
    cover: require('../assets/images/pupfresh.png'),
    tag: [2],
    description: 'This is a landing page for a company.',
    url: 'https://jocular-platypus-61dc93.netlify.app/',
  },
  {
    id: 2,
    name: 'Audius',
    cover: require('../assets/images/audis.png'),
    tag: [2],
    description: 'This is a landing page for a company.',
    url: '/works/audis/index.html',
  },
  {
    id: 3,
    name: 'Shopify Newsletter',
    cover: require('../assets/images/shopify.png'),
    tag: [3, 6],
    description: 'This is a promotional email for a company.',
    url: '/works/shopify/index.html',
  },
  {
    id: 4,
    name: 'Guitar Transactional Email',
    cover: require('../assets/images/guitar.png'),
    tag: [3, 4],
    description: 'This is a promotional email for a company.',
    url: '/works/guitar/index.html',
  },
  {
    id: 5,
    name: 'Cariuma Email',
    cover: require('../assets/images/cariuma.png'),
    tag: [3, 5],
    description: 'This is a promotional email for a company.',
    url: '/works/cariuma/index.html',
  },
  {
    id: 6,
    name: 'Apple Watch Email',
    cover: require('../assets/images/watch.png'),
    tag: [3, 5],
    description: 'This is a promotional email for a company.',
    url: '/works/watch/index.html',
  },
];

export { SKILLS, PROJECTS, PROJECT_FILTERS };
